import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Customer } from '@pos-app/data';
import { DialogService } from '@pos-app/core-ui';
import { NgIf, NgFor, NgClass } from '@angular/common';

@Component({
    selector: 'app-customers-duplicate',
    templateUrl: './customers-duplicate.component.html',
    styleUrls: ['./customers-duplicate.component.scss'],
    imports: [NgIf, NgFor, NgClass]
})
export class CustomersDuplicateComponent implements OnInit {
  public newCustomerDetails: any;
  @Input() set setNewCustomerDetails(value) {
    this.newCustomerDetails = value;
  }
  public duplicateCustomers: Customer[];
  @Input() set setDuplicateCustomers(value) {
    if (value && value.length === 0) {
      this.createNewCustomer();
    }
    this.duplicateCustomers = value;
    // Automatically select the first customer in the list as new default duplicate selection // pbi-4731-bksh
    if (this.duplicateCustomers && this.duplicateCustomers.length > 0) {
      this.selectedCustomer = this.duplicateCustomers[0];
    }
  }
  @Output() customerChoosen = new EventEmitter<Customer>();
  @Output() cancelled = new EventEmitter<void>();
  public selectedCustomer: Customer;

  constructor(     
    private dialogService: DialogService,
    ) {}

  ngOnInit() {}

  selectCustomer(customer) {
    this.selectedCustomer = customer;
  }

  chooseExistingCustomer() {
    if(!this.selectedCustomer ){
      this.dialogService.alert(
        "You must select an existing customer before pressing this button",
        'ERRORS',
        'OK',
        true
      );
    }else{
      this.customerChoosen.emit(this.selectedCustomer);
    }
    
  }

  createNewCustomer() {
    this.customerChoosen.emit(null);
  }

  cancel() {
    this.cancelled.emit();
  }
}

